import React from "react";

import { getReimbursementCurrencySymbol } from "../utils/reimbursementCurrency";

export default function ReimbursementAmount({ amount, currencyType }) {
  const symbol = getReimbursementCurrencySymbol(currencyType);

  return (
    <>
      {symbol ? (
        <span
          style={{
            color: "var(--success)",
            fontWeight: 500,
            fontSize: "medium",
          }}
        >
          {symbol}
        </span>
      ) : null}
      {amount}
    </>
  );
}
